<template>
 <div id="main_div">
   <Navbar></Navbar>
   <!-- Home Section start-->
   <section id="home" class="home">
     <div class="home-decor d-none d-lg-block">
       <div class="home-circle1"><img class="circle-2" :src='"../assets/images/circle-2.png"' alt=""></div>
       <div class="home-circle2"><img class="circle-1" :src='"../assets/images/circle-1.png"' alt=""></div>
       <div class="home-circle3"><img class="circle-3" :src='"../assets/images/circle-3.png"' alt=""></div>
     </div>
     <div class="container">
       <div class="row">
         <div class="col-md-6">
           <div class="home-contain">
             <div class="pl-2 pt-lg-5 mt-lg-5"> 
                <h2 class="text-capitalize mb-4 ml-2" v-html="$t('home.title')"></h2>
                <p class="ml-2 mb-4">{{ $t('home.subtitle') }}</p>
                <div class="mb-4">
                  <a href="#"><img style="max-width: 180px; margin-top: 10px" :src='"../assets/images/appstore.png"' alt="appstore"></a>
                  <a href="#"><img style="max-width: 180px; margin-top: 12px" :src='"../assets/images/play-store.png"' alt="play-store"></a>
                </div>
              <a href="#">
                <img style="max-width: 365px; width: 100%" src="../assets/images/website-logo.png" alt="to website">
              </a>
             </div>
           </div>
         </div>
         <div class="col-sm-6 d-flex justify-content-center align-items-center">
           <!-- <div class="home-right mt-lg-1"> -->
             <!-- Tile js start -->
             <!-- <img style="max-height: 450px" src="../assets/images/home-mobile-1.png" alt="app home screen"> -->
             <Tile max-width="450px" image='home-mobile.jpg'/>
             <!-- Tile js end -->
           <!-- </div> -->
         </div>
       </div>
     </div>
   </section>
   <!--Home Section End -->

   <!-- About Start  -->
   <About/>
   <!-- About End -->

   <!-- Feature Section start -->
   <Feature/>
   <!-- Feature Section End -->
   <Why></Why>
   <!-- Screenshots Section Start -->
   <Screenshots/>
   <!-- Screenshots Section End -->

   <!-- Team Section Start -->
   <!-- <Team/> -->

   <!-- team Section End -->

   <!-- blog Section Start -->
   <!-- <Latest-blog/> -->
   <!-- blog Section End -->

   <!-- Price Section start-->
   <!-- <Price/> -->
   <!-- Price Section End -->

   <!-- testimonial Section start-->
   <!-- <Testimonial/> -->
   <!-- testimonial Section End -->

   <!-- Contact Section start -->
   <!-- <Contact_us/> -->
   <!-- Contact Section End -->

   <!--Subscribe section start-->
   <!-- <Subscribe/> -->
   <!--Subscribe section Ends-->

   <!--Map Section Start-->
   <!-- <Map/> -->
   <!--Map Section Ends-->

   <!-- Footer Section start -->
   <FooterTop></FooterTop>
   <Footer/>
   <!-- Footer Section End -->

   <js/>

 </div>
</template>
<script>
export default {
  name: 'Home_one',
  beforeCreate: function () {
    document.body.className = ''
  },
  data() {
    return {
      locale: localStorage.getItem('locale') || 'th',
    }
  }
}
</script>
<!--remove comment below line to set color -->
<!--<style lang="css">-->
  <!--@import '../public/assets/css/color/color-2.css';-->
<!--</style>-->



// WEBPACK FOOTER //
// src/demo_page/home_one.vue